@if (parcelItemTypesQuery.data(); as itemTypes) {
<div class="pl-4">
  <div class="container mx-auto theme-page-card-bg rounded-lg">
    <nz-page-header [nzTitle]="titleTpl" class="site-page-header">
      <ng-template #titleTpl>
        <div class="text-2xl font-bold">Parcel Item Types</div>
      </ng-template>

      <nz-page-header-extra>
        <button (click)="showAddModal = true" class="btn btn-primary">
          Add Parcel Item Type
        </button>
      </nz-page-header-extra>
    </nz-page-header>

    @if (!itemTypes.length) {
    <section class="max-w-lg px-4 py-12 lg:py-20 mx-auto">
      <img
        class="mx-auto sm:w-4/5"
        height="604"
        ngSrc="luggage.svg"
        width="936"
      />
      <h2 class="mt-8 text-xl font-medium text-center text-gray-800">
        Define the kind of parcels and packages you deliver
      </h2>
      <p class="mt-4 text-center text-gray-600">
        You can allocate standard prices base on the routes under routes
        management.
      </p>
    </section>
    } @if (itemTypes.length) {
    <section class="px-8 mx-auto">
      <nz-table
        #basicTable
        [nzData]="itemTypes"
        [nzLoading]="parcelItemTypesQuery.isPending()"
      >
        <thead>
          <tr>
            <th>Item Type</th>
            <th>Description</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @for (data of itemTypes; track data.id) {
          <tr>
            <td>{{ data.category }}</td>
            <td>{{ data.description }}</td>
            <td>
              <a (click)="showEditModal = true; selected$$.next(data)"
                ><span class="fe fe-edit"></span> Edit</a
              >
              <nz-divider nzType="vertical"></nz-divider>
              <a
                (click)="delete(data)"
                [class.disabled]="deleteMutation.isPending()"
                ><span class="fe fe-delete"></span> Delete</a
              >
            </td>
          </tr>
          }
        </tbody>
      </nz-table>
    </section>
    }
  </div>

  <tenant-add-parcel-item-type
    (hide)="showAddModal = false"
    [show]="showAddModal"
  ></tenant-add-parcel-item-type>

  <tenant-edit-parcel-item-type
    (hide)="showEditModal = false"
    [parcelItemType]="(selected$$ | async)!"
    [show]="showEditModal"
  ></tenant-edit-parcel-item-type>
</div>
} @else if (parcelItemTypesQuery.isPending()) {
<div class="pl-4 flex justify-center items-center h-64">
  <div class="text-center">
    <div class="loading loading-spinner loading-lg"></div>
    <p class="mt-4 text-gray-600">Loading parcel item types...</p>
  </div>
</div>
} @else if (parcelItemTypesQuery.isError()) {
<div class="pl-4 flex justify-center items-center h-64">
  <div class="text-center">
    <div class="text-red-500 text-xl">❌</div>
    <p class="mt-4 text-red-600">Error loading parcel item types</p>
    <button
      (click)="parcelItemTypesQuery.refetch()"
      class="btn btn-outline btn-sm mt-2"
    >
      Retry
    </button>
  </div>
</div>
}
